<template>
  <div :class="{ 'pd-10': type == 'single', 'pd-tp-0': name }" class="expiry_pending" v-on:scroll="deactivatePopover">
    <h3>
      <span class="cursor-pointer" @click="goToLink('/layout/report/status', null)"><img src="/static/images/icons/track_plus_icon_blue.svg" class="dashboard-icons" alt="trackplus-icon" />Expiry Status</span>
    </h3>
    <div class="mt-10">
      <div v-for="(item, key, index) in expiration_details" :key="index">
        <p class="tab_expiry">
          <span v-if="key === 'expired'">Expired</span>
          <span v-if="key === 'month'">Expiring this month</span>
          <span v-if="key === 'quarter'">Expiring next 3 months</span>
          <span v-if="key === 'year'">Expiring this year</span>
          <el-popover placement="bottom" popper-class="popper-custom-class" trigger="hover" width="200" v-model="expiryVisible[index]" v-if="item.products && item.products.length > 0" :disabled="openPopover" @hide="hidePopover">
            <div class="popper-height">
              <p class="cursor-pointer" v-for="(expReg, index) in item.products" :key="index" @click="viewRegistration(expReg.rid, 'expiry', index)">
                {{ expReg.name }}
              </p>
            </div>
            <!-- <template #reference> -->
            <span class="progress_count cursor-pointer" @click="activatePopover" slot="reference">{{ item.number }}</span>
            <!-- </template> -->
          </el-popover>
          <span class="progress_count" v-if="item.products.length === 0">{{ item.number }}</span>
        </p>
        <div class="progress">
          <div
            class="progress-bar"
            :class="{
              red: key === 'expired',
              orange: key === 'month',
              blue: key === 'quarter',
              green: key === 'year',
            }"
            :aria-valuenow="item.number"
            :aria-valuemin="0"
            :aria-valuemax="100"
            :style="{ width: item.number + '%' }"
          ></div>
        </div>
      </div>
    </div>
    <loader :loadingStatus="loaderStatus"></loader>
    <registration-details-popup v-if="dashboardRecordsFlag" :dashboardRecordsFlag="dashboardRecordsFlag" :permissions="permissions" :dataRow="activeRegistration" @hidePopup="hidePopup" @dashboardWidgets="dashboardWidgets" :reportFlag="true"></registration-details-popup>
    <permission-access-modal></permission-access-modal>
  </div>
</template>
<script>
import $ from 'jquery';
import { Popover } from 'element-ui';
import { getDashboardSummary } from '../../../../apis/dashboard';
import Loader from '../../../UIComponents/Loader.vue';
import registrationDetailsPopup from '../../../Registrations/RegistrationDetailsPopup.vue';
import PermissionAccessModal from '../../../Common/PermissionAccessModal.vue';
import { getRegistrationDetailsById } from '../../../../apis/registrations';
import constructRegistrationObject from '../../../../utils/registrationDetails';
// import BasePopover from '../../../Common/BasePopover.vue';

export default {
  data() {
    return {
      dashboardRecordsFlag: false,
      expiration_details: {},
      expiryVisible: [false, false, false, false],
      loaderStatus: false,
      openPopover: false,
      clickPopover: false,
      activeRegistration: {},
      editFlag: '',
    };
  },
  props: ['permissions', 'type', 'name'],
  components: {
    PermissionAccessModal,
    Loader,
    registrationDetailsPopup,
    // BasePopover,
    'el-popover': Popover,
  },
  created() {
    this.getDashboardSummary();
  },
  mounted() {
    $('#registrationDetail').on('hide.bs.modal', this.closeModal);
  },
  methods: {
    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification',
      });
    },

    dashboardWidgets() {
      this.activeRegistration = {};
      this.dashboardRecordsFlag = false;
    },
    goToLink(link, type) {
      if (type === 'pending') {
        this.$router.push({
          name: 'Registration',
          params: { filterRegistration: 'Pending' },
        });
      } else {
        this.$router.push(link);
      }
    },
    async getDashboardSummary() {
      this.loaderStatus = true;
      const { expiration_details: expirationDetails, pending_summary: pendingSummary } = await getDashboardSummary();
      this.pending_summary = pendingSummary;
      this.expiration_details = expirationDetails;
      this.loaderStatus = false;
    },
    async viewRegistration(registrationId, type, index) {
      this.activeRegistration = {};
      this.dashboardRecordsFlag = true;
      if (this.permissions.indexOf('REG_TRACKER_RECORDS') === -1) {
        $('#permissionAccessModal').modal({
          backdrop: 'static',
          keyboard: false,
        });
      } else {
        if (this.userRoleId === 4) {
          return;
        }
        this.loaderStatus = true;
        if (type) {
          if (type === 'expiry') {
            this.expiryVisible[index] = false;
          } else {
            this.pendingVisible[index] = false;
          }
          const all = document.getElementsByClassName('popper-custom-class');
          for (let i = 0; i < all.length; i += 1) {
            all[i].style.display = 'none';
          }
        }
        const selectedRegistration = await getRegistrationDetailsById(registrationId);
        this.loaderStatus = false;
        if (selectedRegistration && selectedRegistration.error) {
          this.clearNotifications();
          this.$notify({
            type: 'error',
            title: 'Error',
            text: 'Registration is not found!',
            group: 'custom-notification',
          });
        } else if (selectedRegistration) {
          this.activeRegistration = constructRegistrationObject(selectedRegistration);
          $('#registrationDetail').modal();
        }
      }
    },
    activatePopover() {
      this.openPopover = false;
      this.clickPopover = true;
    },
    deactivatePopover() {
      if (window.scrollY && this.clickPopover) {
        this.openPopover = true;
      }
    },
    hidePopover() {
      this.clickPopover = false;
    },
    hidePopup(value) {
      this.editFlag = value;
    },
    closeModal(e) {
      this.activeRegistration = {};
      if (this.editFlag) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      this.activeId = '';
      return true;
    },
  },
};
</script>
<style scoped>
.pd-10 {
  padding: 10px;
}
.expiry_pending h3 {
  margin: 0;
  line-height: 28px;
  font-size: 22px;
  font-weight: 500;
  color: #0b3c61;
}
.pd-tp-0 {
  padding-top: 0px !important;
}
.expiry_pending .tab_expiry {
  font-size: 14px;
  line-height: 16px;
  margin-top: 12px;
  margin-bottom: 6px;
  display: flex;
  justify-content: space-between;
}
.expiry_pending .progress_count {
  float: right;
  font-size: 14px;
  line-height: 16px;
}
.expiry_pending .green {
  background: #27ae60;
}
.expiry_pending .orange {
  background: #f2994a;
}
.expiry_pending .blue {
  background: #2f80ed;
}
.expiry_pending .red {
  background: #eb5757;
}
.expiry_pending .progress {
  height: 11px;
  margin-bottom: 0;
  background: #c4c4c4;
  box-shadow: none;
}
.widget {
  min-height: 275px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  padding: 15px;
  background: #ffffff;
}
.mt-10 {
  margin-top: 10px;
}
.cursor-pointer {
  cursor: pointer !important;
  word-break: break-all;
  white-space: normal;
}
@media only screen and (max-width: 1024px) {
  .widget {
    margin-bottom: 20px !important;
    min-height: 245px !important;
  }
}
.icon-reg-expiry {
  width: 24px;
  height: 24px;
  margin-right: 6px;
  margin-top: -3px;
}
</style>
